import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import SoundAssetKeys from '../SoundAssetKeys';
import { dotPop } from '../Utils';
import Game from './Game';
import LocalizationUIAssets from '../Localization-UIAssets';

export default class TitleScreen extends Phaser.Scene {
  static get KEY() { return 'TitleScreen'; }

  constructor() {
    super({ key: TitleScreen.KEY });
  }

  create() {
    this.bg = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._LandscapeMainBackground_4x3,this).setOrigin(0);
    this.title = ABCyaPhaser.Images.addImage(this.scale.width / 2,this.scale.height / 2 - 20,LocalizationUIAssets._Title, this, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setScale(0);
    this.btnGo = this.add.container(this.scale.width / 2, this.scale.height - 120).setScale(0);

    // go button bg
    ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._BtnGo, this.btnGo).setInteractive()
      .once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.clickGo, this);

    // go button txt
    this.btnGo.add(this.add.bitmapText(0,-3,'bpreplay-bold', ABCyaPhaser.Localization.instance.getLocalizedString('go_button'), 42, Phaser.GameObjects.BitmapText.ALIGN_CENTER).setOrigin(0.5));

    dotPop(this.title, 440);
    dotPop(this.btnGo, 440, 420);

    this.introMusic = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._intro_theme_new, this.introMusic, 1, true);
  }

  clickGo () {
    this.nextScene();
  }

  nextScene () {
    this.introMusic.stop();
    this.introMusic.destroy();
    this.introMusic = null;
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
    this.scene.start(Game.KEY);
  }
}